<template>
  <header :class="['header', { scrolled: isScrolled }]">
    <a href="#" class="logo"><span>EM.</span></a>
    <i class="fa-solid fa-bars" id="menu-icon" @click="toggleMenu"></i>
    <ul :class="['nav-links', { show: menuOpen }]">
      <li><a href="#home" @click="closeMenu">Accueil</a></li>
      <li><a href="#about" @click="closeMenu">A propos</a></li>
      <li><a href="#skills" @click="closeMenu">Compétences</a></li>
      <li><a href="#projects" @click="closeMenu">Projets</a></li>
      <li><a href="#contact" @click="closeMenu">Contact</a></li>
    </ul>
  </header>
  <section id="home" class="home">
    <div class="home-container">
      <div class="home-box">
        <div>
          <div class="home-titles">
            Bonjour, Je suis
            <h1>Elise Metayer</h1>
          </div>
          <h2>Ingénieure en Informatique & Full Stack Développeuse</h2>
        </div>
        <div class="home-btn-group">
          <a
            href="/documents/CV_DEVELOPPEUR_WEB.pdf"
            download
            class="btn-primary"
          >
            Télécharger mon CV
          </a>
          <a href="#contact" class="btn-secondary">Contacter</a>
        </div>
      </div>
    </div>
  </section>
  <section id="about" class="about">
    <div class="about-container">
      <div class="about-box">
        <h3>A PROPOS DE MOI</h3>
        <div class="present-box">
          <img src="../assets/images/profile.jpg" alt="Profile Picture" />
          <p>
            Je suis passionnée par le développement web, j'ai 1 an d'expérience
            en conception d'application web combinant des fonctionnalités
            puissantes avec un design élégant.
          </p>
        </div>
        <div class="about-grid">
          <div class="about-card">
            <div class="icon">
              <i class="fa-solid fa-code"></i>
            </div>
            <h4>Code Propre</h4>
            <p>
              Écriture de code propre et bien structuré. Suivi des bonnes
              pratiques de développement.
            </p>
          </div>
          <div class="about-card">
            <div class="icon">
              <i class="fa-solid fa-palette"></i>
            </div>
            <h4>Design élégant</h4>
            <p>Création de designs intuitifs et attrayants.</p>
          </div>
          <div class="about-card">
            <div class="icon">
              <i class="fa-solid fa-bolt"></i>
            </div>
            <h4>Performance</h4>
            <p>
              Optimisation des applications pour la vitesse et une expérience
              utilisateur fluide.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section id="skills" class="skills">
    <div class="skills-container">
      <h3>COMPÉTENCES</h3>
      <div class="swiper">
        <div class="skills-card-wrapper">
          <ul class="skills-card-list swiper-wrapper">
            <li class="skill-card swiper-slide">
              <h4>Frontend</h4>
              <div class="skill-item">
                <span>Angular</span>
                <span class="percent">50%</span>
                <div class="progress-bar">
                  <div class="progress" style="width: 50%"></div>
                </div>
              </div>
              <div class="skill-item">
                <span>Vue JS</span>
                <span class="percent">70%</span>
                <div class="progress-bar">
                  <div class="progress" style="width: 70%"></div>
                </div>
              </div>
              <div class="skill-item">
                <span>HTML/SCSS</span>
                <span class="percent">85%</span>
                <div class="progress-bar">
                  <div class="progress" style="width: 85%"></div>
                </div>
              </div>
            </li>
            <li class="skill-card swiper-slide">
              <h4>Backend</h4>
              <div class="skill-item">
                <span>Node.js</span>
                <span class="percent">55%</span>
                <div class="progress-bar">
                  <div class="progress" style="width: 55%"></div>
                </div>
              </div>
              <div class="skill-item">
                <span>Java / Springboot</span>
                <span class="percent">80%</span>
                <div class="progress-bar">
                  <div class="progress" style="width: 80%"></div>
                </div>
              </div>
              <div class="skill-item">
                <span>Python</span>
                <span class="percent">75%</span>
                <div class="progress-bar">
                  <div class="progress" style="width: 75%"></div>
                </div>
              </div>
            </li>
            <li class="skill-card swiper-slide">
              <h4>Bases de données</h4>
              <div class="skill-item">
                <span>SQL</span>
                <span class="percent">60%</span>
                <div class="progress-bar">
                  <div class="progress" style="width: 60%"></div>
                </div>
              </div>
              <div class="skill-item">
                <span>MongoDB</span>
                <span class="percent">75%</span>
                <div class="progress-bar">
                  <div class="progress" style="width: 75%"></div>
                </div>
              </div>
              <div class="skill-item">
                <span>ElasticSearch</span>
                <span class="percent">60%</span>
                <div class="progress-bar">
                  <div class="progress" style="width: 60%"></div>
                </div>
              </div>
            </li>
            <li class="skill-card swiper-slide">
              <h4>Outils informatiques</h4>
              <div class="skill-item">
                <span>Git</span>
                <span class="percent">75%</span>
                <div class="progress-bar">
                  <div class="progress" style="width: 75%"></div>
                </div>
              </div>
              <div class="skill-item">
                <span>Figma</span>
                <span class="percent">60%</span>
                <div class="progress-bar">
                  <div class="progress" style="width: 60%"></div>
                </div>
              </div>
              <div class="skill-item">
                <span>DevTools</span>
                <span class="percent">50%</span>
                <div class="progress-bar">
                  <div class="progress" style="width: 50%"></div>
                </div>
              </div>
              <div class="skill-item">
                <span>Jira</span>
                <span class="percent">90%</span>
                <div class="progress-bar">
                  <div class="progress" style="width: 90%"></div>
                </div>
              </div>
            </li>
            <li class="skill-card swiper-slide">
              <h4>Soft Skills</h4>
              <div class="skill-item">
                <span>Anglais (CLES)</span>
                <span class="percent">75%</span>
                <div class="progress-bar">
                  <div class="progress" style="width: 75%"></div>
                </div>
              </div>
              <div class="skill-item">
                <span>Travail en équipe</span>
                <span class="percent">95%</span>
                <div class="progress-bar">
                  <div class="progress" style="width: 95%"></div>
                </div>
              </div>
              <div class="skill-item">
                <span>Gestion de projet</span>
                <span class="percent">65%</span>
                <div class="progress-bar">
                  <div class="progress" style="width: 66%"></div>
                </div>
              </div>
              <div class="skill-item">
                <span>Autonomie</span>
                <span class="percent">80%</span>
                <div class="progress-bar">
                  <div class="progress" style="width: 80%"></div>
                </div>
              </div>
            </li>
          </ul>
          <div class="swiper-pagination"></div>
          <div class="swiper-slide-button swiper-button-prev"></div>
          <div class="swiper-slide-button swiper-button-next"></div>
        </div>
      </div>
    </div>
  </section>
  <section id="projects" class="projects">
    <div class="projects-container">
      <div class="project-box">
        <h3>MES PROJETS</h3>
        <ProjectCard
          title="Application de suivi d'interventions"
          description="Application intuitive qui permet à l'utilisateur de tracker ses interventions de maintenance sur différentes machines. Avec un tableau pour pouvoir consulter les interventions effectuées, un boutons d'ajout d'intervention, un système de filtre, et un bouton d'export vers un format csv."
          :image="reportingApp"
          icon="fa-solid fa-gear"
          :techStack="[
            { icon: 'fa-brands fa-vuejs', label: 'Vue.js' },
            { icon: 'fa-brands fa-node-js', label: 'Node.js' },
            { icon: 'fa-solid fa-leaf', label: 'MongoDB' },
            { icon: 'fa-brands fa-square-figma', label: 'Figma' },
          ]"
        />
      </div>
    </div>
  </section>
  <section id="contact" class="contact">
    <div class="contact-container">
      <div class="contact-box">
        <h5>Informations de contact</h5>
        <div class="details-box">
          <i class="fa-solid fa-envelope contact-icon"></i>
          <div class="details-text">
            <h2>Email</h2>
            <p>elise.metayer.22@hotmail.fr</p>
          </div>
        </div>
        <div class="details-box">
          <i class="fa-solid fa-map-location-dot contact-icon"></i>
          <div class="details-text">
            <h2>Localisation</h2>
            <p>Montpellier, Occitanie</p>
          </div>
        </div>
        <div class="details-box">
          <i class="fa-brands fa-linkedin contact-icon"></i>
          <div class="details-text">
            <h2>Linkedin</h2>
            <a
              href="https://www.linkedin.com/in/elise-metayer-843b72254"
              target="_blank"
              >www.linkedin.com/in/elise-metayer-843b72254</a
            >
          </div>
        </div>
      </div>
      <div class="form-box">
        <h1>Contactez-moi</h1>
        <p>
          Tu as un projet en tête ou tu veux juste discuter ? Envoie moi un
          message !
        </p>
        <form class="contact-form" @submit.prevent="submitForm">
          <input type="text" placeholder="Nom" v-model="form.name" />
          <input type="email" placeholder="Email" v-model="form.email" />
          <textarea placeholder="Message" v-model="form.message"></textarea>

          <button type="submit" class="btn-primary">
            {{ loading ? "Envoi..." : "Envoyer" }}
          </button>

          <p v-if="success" style="color: #4ade80">Message envoyé</p>
          <p v-if="error" style="color: #f87171">{{ error }}</p>
        </form>
      </div>
    </div>
  </section>
  <footer>
    <p>© 2025 Elise Metayer. Tous droits réservés.</p>
  </footer>
</template>

<script>
import ProjectCard from "./ProjectCard.vue";

import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import reportingApp from "@/assets/images/reporting-app.png";

export default {
  name: "HomePage",
  components: {
    ProjectCard,
  },
  data() {
    return {
      isScrolled: false,
      menuOpen: false,

      //Contact form data
      form: {
        name: "",
        email: "",
        message: "",
      },

      loading: false,
      success: false,
      error: null,

      swiper: null,

      //Image imports
      reportingApp,
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);

    // Initialisation Swiper
    new Swiper(".skills-card-wrapper", {
      modules: [Navigation, Pagination],
      loop: true,
      spaceBetween: 20,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
        dynamicBullets: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      //Responsive breakpoints
      breakpoints: {
        0: {
          slidesPerView: 1,
        },
        768: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 3,
        },
      },
    });
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      this.isScrolled = window.scrollY > 50;
    },
    toggleMenu() {
      this.menuOpen = !this.menuOpen;
    },
    closeMenu() {
      this.menuOpen = false;
    },
    async submitForm() {
      this.loading = true;
      this.success = false;
      this.error = "";

      const API_URL = process.env.VUE_APP_API_URL;
      const API_KEY = process.env.VUE_APP_API_KEY;
      const DESTINATAIRE = process.env.VUE_APP_EMAIL_DESTINATAIRE;

      try {
        const response = await fetch(API_URL, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "x-api-key": API_KEY,
          },
          body: JSON.stringify({
            name: this.form.name,
            email: this.form.email,
            message: this.form.message,
            to: DESTINATAIRE,
          }),
        });

        const data = await response.json();
        if (data.success) {
          this.success = true;
          this.form.name = "";
          this.form.email = "";
          this.form.message = "";
        } else {
          this.error = data.error || "Une erreur est survenue";
        }
      } catch (err) {
        console.error(err);
        this.error = "Impossible d'envoyer le message";
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss">
/* HEADER */
.logo {
  color: #e2eff6;
  font-size: 1.5rem;
  font-weight: 600;
  text-wrap: nowrap;
}

.logo:hover {
  transform: scale(1.1);
}

.nav-links {
  display: flex;
  gap: 1.5rem;
}

#menu-icon {
  font-size: 1.5rem;
  display: none;
}

/*  -------------------------------- HOME ----------------------------------------------------- */
.home {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #e2eff6;
  // overflow: hidden;

  /*background image*/
  background: url("../assets/images/background_work_op.png") center/cover
    no-repeat;
}

/* filter (overlay) */
.home::before {
  content: "";
  position: absolute;
  inset: 0;
  background: #10172c99; /* COLOR + OPACITY */
  backdrop-filter: blur(4px);
  z-index: 1;
}

.home-container {
  z-index: 2; //put it before the overlay filter
}

.home-titles {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 12px;

  font-size: 4rem;
  font-weight: 400;
}

.home-box {
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;
  justify-content: center;
  gap: 2rem;
}

.home-btn-group {
  display: flex;
  gap: 1rem;
  justify-content: center;
}

/* -------------------------------------------------------------------------------------------------- */
/* -------------------------------------- ABOUT ----------------------------------------------------- */
.about {
  background: #10172c;
  display: flex;
  justify-content: center;
  color: #e2eff6;
}
.about-container {
  max-width: 1300px;
  text-align: center;
}
.about-box {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.present-box {
  width: 100%;
  padding: 0rem 2rem;
  align-items: center;

  display: flex;
  gap: 20px;

  img {
    width: 150px;
    height: 150px;
    border-radius: 50%;
    object-fit: cover;
    border: 2px solid #1f2937;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.4);
  }
}

.about-grid {
  margin-top: 40px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
  width: 100%;
  max-width: 1300px;

  .about-card {
    background: #162032;
    border-radius: 16px;
    padding: 35px 25px;
    text-align: left;
    color: #ffffff;
    transition: 0.3s;
    border: 1px solid rgba(255, 255, 255, 0.05);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.25);

    &:hover {
      transform: translateY(-5px);
      background: #1b263a;
    }

    .icon {
      width: 52px;
      height: 52px;
      border-radius: 12px;
      background: #1e3a8a;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 20px;

      i {
        font-size: 22px;
        color: #a5c4ff;
      }
    }
  }
}
/* -------------------------------------------------------------------------------------------------- */
/* -------------------------------------- SKILLS ----------------------------------------------------- */
.skills {
  background: #1e2738;
  display: flex;
  justify-content: center;
}

.skills-container {
  display: flex;
  flex-direction: column;
  max-width: 1300px;
  width: 100%;
  text-align: center;
  justify-content: center;
  align-items: center;
}

.swiper {
  width: 90%;
  display: flex;
  justify-content: center;
}

.skill-card {
  display: block;
  user-select: none; // Disable text selection
  cursor: pointer;

  background: #0f172a;
  padding: 30px;
  height: 400px;

  border-radius: 16px;
  color: #e2eff6;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.3);
  transition: 0.3s ease;

  &:hover {
    transform: translateY(-5px);
  }
}

.skill-card:active {
  cursor: grabbing;
}

.swiper-slide-button {
  color: #3b82f6;
  cursor: pointer;
  z-index: 10;
}

.skills-card-wrapper {
  max-width: 980px;
  margin: 0 40px 25px;
  padding: 20px 10px;
  overflow: hidden;
}

.skill-item {
  margin-bottom: 25px;
  text-align: left;

  display: flex;
  flex-direction: column;
  gap: 5px;

  span {
    font-size: 1rem;
  }

  .percent {
    color: #60a5fa;
    font-weight: 600;
    align-self: flex-end;
    margin-top: -22px;
  }
}

.progress-bar {
  width: 100%;
  height: 8px;
  background: #334155;
  border-radius: 10px;
  overflow: hidden;

  .progress {
    height: 100%;
    background: #3b82f6;
    border-radius: 10px;
    transition: width 0.7s ease;
  }
}

/*---------------------------------------------------------------------------------------------------*/
/*--------------------------------------PROJECT-------------------------------------------------------*/
.projects {
  background: #10172c;
  display: flex;
  justify-content: center;
  color: #e2eff6;
}
.projects-container {
  max-width: 1300px;
  text-align: center;
}

.project-box {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* -------------------------------------------------------------------------------------------------- */
/* -------------------------------------- CONTACT ----------------------------------------------------- */
.contact {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #e2eff6;
  text-align: center;
  overflow: hidden;
  padding-top: 2rem;

  /*background image*/
  background: url("../assets/images/phones.png") center/cover no-repeat;
}

.contact-container {
  display: flex;
  position: relative;
  z-index: 2;

  left: 15%;
  gap: 2rem;
}

.contact .details-box {
  display: flex;
  gap: 1rem;
  margin-right: 3rem;
  align-items: center;
}

.contact-box {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  margin-right: 1rem;
  justify-content: left;
  text-align: left;
}

.details-text {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  text-align: left;
  color: #10172c;
}

.details-box h2 {
  font-size: 1rem;
  font-weight: 500;
}

.contact-icon {
  background-color: #10172c;
  padding: 0.8rem 0.5rem;
  width: 3rem;
  border-radius: 0.5rem;
  // height: 2.5rem;
  font-size: 1.5rem;
}

.contact .form-box {
  position: relative;
  width: 40%;

  display: flex;
  flex-direction: column;
  gap: 1rem;
  background-color: #10172c;
  padding: 2rem 3rem 6rem 3rem;
  border-radius: 0.5rem;

  justify-content: center;
}

.form-box h1 {
  font-size: 2.5rem;
  font-weight: 500;
}

.form-box p {
  color: #d1d5db;
  margin-bottom: 1rem;
}

.contact-form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
}

input,
textarea {
  width: 80%;
  background-color: #1e293b; // slate-800
  border: 1px solid #334155; // slate-700
  color: white;
  padding: 0.5rem 0.75rem;
  border-radius: 0.375rem;
  outline: none;
  transition: border-color 0.2s;

  &:focus {
    border-color: #3b82f6; // blue-500
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
  }

  &::placeholder {
    color: #64748b; // slate-500
  }
}

/* Mobile */
@media (max-width: 768px) {
  header {
    justify-content: space-between;
    padding: 1rem;
  }

  .nav-links {
    position: absolute;
    top: 100%;
    right: 0;
    background: #10172c;
    backdrop-filter: blur(8px);
    width: 100vw;
    height: 100vh;
    flex-direction: column;
    gap: 2.5rem;
    padding: 1.5rem 0;
    align-items: center;
    font-size: 1.5rem;
    display: none; /* hide by default */
  }

  .nav-links.show {
    display: flex; /* showed on click */
  }

  #menu-icon {
    display: block;
    cursor: pointer;
    color: #e2eff6;
  }

  /* ---------------------------------------- HOME MOBILE ----------------------------------------------- */

  .home-box {
    gap: 4rem;
  }
  .home-titles {
    display: flex;
    flex-direction: column;
    gap: 0;
    font-size: 1.5rem;
    font-weight: 500;

    margin-bottom: 1rem;
  }
  .home-btn-group {
    flex-direction: column;
  }

  /* ----------------------------------------- ABOUT MOBILE --------------------------------------------- */

  .present-box {
    padding: 0.5rem;
    display: flex;
    flex-direction: column;
    gap: 10px;

    img {
      width: 200px;
      height: 200px;
    }
  }

  .about-grid {
    grid-template-columns: 1fr;
    margin-top: 1rem;
  }

  /* ----------------------------------------- SKILLS MOBILE --------------------------------------------- */
  .swiper-slide-button {
    display: none;
  }

  .skills-card-wrapper {
    margin: 0 10px 25px;
    padding: 10px 0px;
  }

  /* ----------------------------------------- CONTACT MOBILE --------------------------------------------- */

  .contact {
    padding: 2rem 1rem;
    background-position: center;
    background-size: cover;
  }

  .contact-container {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    left: 0; /* supprime le décalage */
    gap: 2rem;
    width: 100%;
  }

  .contact-box {
    width: 100%;
    padding: 1rem;
    margin-right: 0;
    gap: 1rem;
    align-items: flex-start;
  }

  .details-box {
    flex-direction: row;
    margin-right: 0;
    width: 100%;
  }

  .details-text {
    text-align: left;
  }

  .contact-icon {
    width: 2.8rem;
    font-size: 1.2rem;
  }

  /* FORMULAIRE MOBILE */
  .contact .form-box {
    width: 85%;
    padding: 2rem;
    border-radius: 0.5rem;
    gap: 1.5rem;
  }

  .form-box h1 {
    font-size: 1.4rem;
  }

  .form-box p {
    display: none;
  }

  .contact-form {
    width: 100%;
  }

  .contact-form input,
  .contact-form textarea {
    width: 100%;
  }
}
</style>
